// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonFooter_button___Vo92","buttonActive":"ButtonFooter_buttonActive__MnF8N"};